import {
    getDictionaryDetailByCode
} from '../api/appointment';

// 查询导出限制天数
export const maxDay = 1000 * 60 * 60 * 24 * 31;

const common = {
    setSessionStorage: key => {
        !sessionStorage[key] && common._getDictionaryDetailByCode(key).then(res => {
            sessionStorage[key] = JSON.stringify(res[key]);
        });
    },
    // 获取数据字典
    _getDictionaryDetailByCode: key => {
        return getDictionaryDetailByCode({ dictCodes: key }).then(res => {
            if (res && +res.code === 0) {
                return res.data;
            }
        });
    },
    // 转化session内的值
    getSessionKey: (prop, key) => {
        return prop && key ? JSON.parse(key)[prop] : prop;
    },
    // 初始化遍历所有key
    initSessionData(arr) {
        arr.forEach(item => {
            common.setSessionStorage(item);
        });
    }
};
export default common;